"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./styles");

var _underscore = require("underscore");

var _classnames = _interopRequireDefault(require("classnames"));

var _OverlayTrigger = _interopRequireDefault(require("react-bootstrap/es/OverlayTrigger"));

var _Popover = _interopRequireDefault(require("react-bootstrap/es/Popover"));

var _googleMaps = require("../../lib/google-maps");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var CityInput,
    boundMethodCheck = function boundMethodCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new Error('Bound instance method accessed before binding');
  }
};

var _default = CityInput = function () {
  var CityInput =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(CityInput, _React$Component);

    function CityInput(props) {
      var _this;

      _classCallCheck(this, CityInput);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(CityInput).apply(this, arguments));
      _this.addressText = _this.addressText.bind(_assertThisInitialized(_this)); // onSelect: (data)=>
      //   @props.onChange comps2obj data
      // nulls the data if the input is cleared

      _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
      _this.autoComplete = _this.autoComplete.bind(_assertThisInitialized(_this));
      _this.acService = new google.maps.places.AutocompleteService();
      _this.geocoder = new google.maps.Geocoder(); // @autoComplete = debounce , 300

      _this.state = {
        input: null,
        location: props.location,
        results: []
      };
      return _this;
    }

    _createClass(CityInput, [{
      key: "addressText",
      value: function addressText() {
        var l;
        boundMethodCheck(this, CityInput);

        if (!(l = this.state.location)) {
          return '';
        }

        return [l.city, l.region].join(', ');
      }
    }, {
      key: "onChange",
      value: function onChange(data) {
        boundMethodCheck(this, CityInput);

        if (!(data != null ? typeof data.trim === "function" ? data.trim() : void 0 : void 0)) {
          return this.props.onChange(null);
        }
      }
    }, {
      key: "chooseResult",
      value: function chooseResult(result) {
        var _this2 = this;

        var place_id;
        place_id = result.place_id;
        return this.geocoder.geocode({
          placeId: place_id
        }, function (results) {
          var loc;

          if (loc = (0, _googleMaps.result2obj)(results != null ? results[0] : void 0)) {
            return _this2.setState({
              input: null,
              location: loc
            });
          }
        });
      }
    }, {
      key: "autoComplete",
      value: function autoComplete(evt) {
        var ref, val;
        boundMethodCheck(this, CityInput);

        if (val = (ref = evt.target) != null ? ref.value : void 0) {
          this.setState({
            input: val
          });
          return this.debouncedAutoComplete(val);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var search_placeholder;
        search_placeholder = this.props.intl.formatMessage({
          id: 'library.navbar.search_cities',
          defaultMessage: 'Search cities'
        });
        return _react.default.createElement(_OverlayTrigger.default, {
          trigger: "focus",
          placement: "bottom",
          overlay: this.choices()
        }, _react.default.createElement("input", {
          type: "text",
          value: this.state.input || this.addressText(),
          placeholder: this.props.placeholder || search_placeholder,
          onChange: this.autoComplete
        }));
      } // render: ->
      //   <div className="UserDropdown" onClick={@togglePopup} >
      //     <div className="user">
      //         <div ref={(el)=> @_trigger = el}>
      //           <Avatar size={32} user={@props.user}/>
      //         </div>
      //       <span className="user-name">{@props.user.first_name}</span>
      //     </div>
      //   </div>

    }, {
      key: "choices",
      value: function choices() {
        var main_text, ref, result, secondary_text, style;
        style = {
          display: ((ref = this.state.results) != null ? ref.length : void 0) ? 'block' : 'hidden'
        };
        return _react.default.createElement(_Popover.default, {
          id: "results-dropdown",
          style: style,
          arrowOffsetLeft: '20px'
        }, function () {
          var i, len, ref1, results1;
          ref1 = this.state.results;
          results1 = [];

          for (i = 0, len = ref1.length; i < len; i++) {
            result = ref1[i];
            var _result$structured_fo = result.structured_formatting;
            main_text = _result$structured_fo.main_text;
            secondary_text = _result$structured_fo.secondary_text;
            results1.push(_react.default.createElement("div", {
              className: "result",
              onClick: this.chooseResult.bind(this, result)
            }, _react.default.createElement("span", {
              className: "primary"
            }, main_text), _react.default.createElement("span", {
              className: "secondary"
            }, secondary_text)));
          }

          return results1;
        }.call(this));
      }
    }]);

    return CityInput;
  }(_react.default.Component);

  ;
  CityInput.propTypes = {
    placeholder: _propTypes.default.string,
    location: _propTypes.default.object,
    onChange: _propTypes.default.func.isRequired
  };
  CityInput.defaultProps = {
    location: null
  };
  CityInput.prototype.debouncedAutoComplete = (0, _underscore.debounce)(function (text) {
    var _this3 = this;

    return this.acService.getPlacePredictions({
      input: text,
      types: ['(cities)']
    }, function (results) {
      return _this3.setState({
        results: results || []
      });
    });
  }, 200);
  return CityInput;
}.call(void 0);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/navbar/city-input.js
// module id = 1482
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16